import { LandingPurposes } from "clearline-api";

export class VariableMetaData {
  name: string;
  category: string;
  description: string;
  defaultValue: string;
  purposeId: LandingPurposes;
}
